<template>
  <div>
    <!-- Header -->
    <div class="header py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-light">¡Oops!</h1>
              <p class="text-lead text-white">Página no encontrada. No importa, tenemos más que visitar.</p>

              <router-link to="/dashboard" class="font-weight-bold text-white mt-5">Volver a dashboard</router-link>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'not-found'
};
</script>

<style>
  .main-content {
    height: 820px;
  }
</style>
